export const TYRES_OPA_DASHBOARD: string = 'dashboard';
export const TYRES_OPA_MOVEMENT: string = 'movements';
export const TYRES_OPA_DETAIL: string = 'detail';

export const TYRES_OPA_TYRES_WAREHOUSE_CONTRACTS: string = 'tyres-warehouse-contracts';
export const TYRES_OPA_TYRES_DETAILS: string = 'tyres-details';
export const TYRES_OPA_CONTRACTS_DETAILS: string = 'contracts-details';
export const TYRES_OPA_WAREHOUSE_DETAILS: string = 'warehouse-details';
